export default "__VITE_ASSET__a1bfc958__"